import React from "react";
import { useTranslation } from "react-i18next";
import AnimatedSection from "../../components/AnimatedSection/AnimatedSection";
import ProjectCard from "../../components/ProjectCard/ProjectCard";
import { PROJECTS } from "../../data/projects";
import { IMAGES } from "../../data/constants";
import "./Projects.css";

function Projects() {
  const { t } = useTranslation();

  return (
    <div className="projects-page" style={{ paddingTop: 66 }}>

      {/* Hero */}
      <div className="page-hero projects-page__hero">
        <img src={IMAGES.strip[3]} alt="SK Associate projects portfolio — India" className="hero-bg" />
        <div className="hero-overlay" />
        <div className="hero-content container">
          <p className="section-label">{t("projects_page.label")}</p>
          <h1 className="projects-page__title">{t("projects_page.title")}</h1>
          <p className="projects-page__subtitle">
            {t("projects_page.subtitle")}
          </p>
        </div>
      </div>

      {/* Grid */}
      <section className="section" style={{ background: "var(--bg)" }}>
        <div className="container">
          <div className="projects-page__grid">
            {PROJECTS.map((p, i) => (
              <AnimatedSection key={p.id} delay={i * 0.09}>
                <ProjectCard project={p} />
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}

export default Projects;
